import { Badge, Flex, HStack, Icon, Text } from "@chakra-ui/react";
import { FiShoppingBag } from 'react-icons/fi';
import { useHistory } from "react-router-dom";

import { useCart } from "../../hooks/cart";
// import PopoverUser from "./PopoverUser";

interface NotifivationNavProps {
	isOpenCart?: (open: boolean) => void;
}

const NotificationNav: React.FC<NotifivationNavProps> = ({ isOpenCart }) => {
	const { cart } = useCart();
	const history = useHistory();

	return (
		<HStack
			spacing={["2", "4"]}
			mr="2"
			ml={["-40", "0"]}
			pr={["3", "4"]}
			py="0"
			color="gray.300"
			borderRightWidth={1}
			borderColor="gray.700"
		>
			<Flex
				as="button"
				onClick={() => isOpenCart ? isOpenCart(true) : null}
				position="relative"
			>
				<Icon
					as={FiShoppingBag}
					fontSize={["20", "28"]}
          color={history.location.pathname === '/products' ? 'white' : 'gray.300'}
					_hover={{ color: "blue.100" }}
				/>

				{cart.items && cart.items.length > 0  && (
					<Badge
						h={["18px", "22px"]}
						w={["18px", "22px"]}
						display="flex"
						alignItems="center"
						justifyContent="center"
						variant='solid'
						fontSize={['0.5em', '0.7em']}
						colorScheme='blue'
						borderRadius="50%"
						bottom={-2}
						right={-2}
						position="absolute"
						borderWidth={2}
						borderColor="gray.800"
					>
						<Text
							px={cart.items.length < 10 ? '0.2' : '0'}
							pt="0"
						>
							{cart.items.length}</Text>
					</Badge>
				)}
			</Flex>

			{/* <PopoverUser /> */}
		</HStack>
	)
}

export default NotificationNav;
